import "./cart_summary_helpers";
import "./cart-summary-promotion";
import ApplyCouponSubmitButtonEvent from "./submitCoupon";
import { CartSummary } from "./cart_summary/CartSummary";
import { createCookie, readCookie } from "./cookie-helper";
import loadingIndicator from "../new-boost/js/loading_indicator";
import {
    accountEmailErrorIndicator,
    accountEmailDisabledErrorIndicator,
} from "../new-boost/js/account_email_error";
import GenericBoostModal from "./generic-boost-modal";
import { GetUrlContextParametersString, GetURLParameter } from "./helpers";
import "./plugins/scroll-absolute-gallery";
import "../../launchpad/js/jquery-plugins/slideshow";

import "../../darwin/node_modules/timepicker/jquery.timepicker";
import "../../darwin/node_modules/timepicker/jquery.timepicker.css";
import showAddPaymentButton from "../new-boost/js/show_add_payment_button";

jQuery(function () {
    initFancybox();
    initRetinaCover();
    ApplyCouponSubmitButtonEvent();
    new CartSummary();
    initGetLayoutEventHandlers();
    initTermsOfUse();
    initSlideShow();
    initCycleCarousel();
    saveAgentHandlers();
    initLaunchPadFacebook();
    closeWebviewEventHandler();
    goBackButtonHandler();
    initMlsNumberAndAddressAutocomplete();
    initLaunchpadCustomForms();
    try {
        initStripe();
    } catch (e) {
        if (e.message.indexOf("must use HTTPS") != 0) {
            //ignore the error ... live stripe just doesn't work locally
        }
    }
});

function initMlsNumberAndAddressAutocomplete() {
    let isMobile =
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    //MLS SEARCH - used in Launchpad and the Boost Dashboard
    jQuery("input.autocomplete-mls-number").each(function () {
        var input = jQuery(this);
        var holder = input.closest(".input-holder");
        var url = input.data("autocomplete-url");
        if (holder.find("input[name=address]").val()) {
            if (holder.find("input[name=searchable_mls_number]").val()) {
                $("#input1").val(
                    holder.find("input[name=address]").val() +
                        " - MLS#" +
                        holder.find("input[name=searchable_mls_number]").val()
                );
            } else {
                $("#input1").val(
                    holder.find("input[name=address]").val() +
                        " - MLS#" +
                        holder.find("input[name=mls_number]").val()
                );
            }
            $("#submit").css("display", "inline-block");
            $("#input1").attr("disabled", true);
            $("#cleartextbutton1").css("display", "inline-block");
        } else {
            $("#input1").focus();
        }

        input.click(function () {
            if ($(this).val() !== "") {
                input.autocomplete("search");
            }
        });

        var lastMlsSearch = null;

        input.uiAutocomplete({
            request: function (search, callback) {
                $("#loadingbutton1").css("display", "inline-block");
                if (lastMlsSearch) {
                    lastMlsSearch.abort();
                }
                lastMlsSearch = jQuery.getJSON(url, { v: 1, q: search.term });
                lastMlsSearch.done(function (rsp) {
                    var items = [];
                    jQuery.each(rsp, function (idx, x) {
                        if (x.type === "LISTING") {
                            if (x.display.indexOf("MLS#") !== -1) {
                                items.push({
                                    label: x.display,
                                    value: x.mlsId + ":" + x.mls,
                                });
                            } else {
                                items.push({
                                    label:
                                        x.display +
                                        " - MLS# " +
                                        x.searchable_mls_number,
                                    value: x.mlsId + ":" + x.mls,
                                });
                            }
                        }
                    });
                    if (items.length === 0) {
                        $("#found, #submit").hide();
                        $("#not-found").css("display", "inline-block");
                        $("#not-found2").css("display", "inline-block");
                    } else {
                        $("#not-found, #not-found2, #submit").hide();
                        $("#found").css("display", "inline-block");
                    }
                    $("#loadingbutton1").css("display", "none");
                    callback(items);
                });
            },
            select: function (event, ui) {
                event.preventDefault();
                $(this).val($("<div>" + ui.item.label + "</div>").text());
                var parts = ui.item.value.split(":");
                var mlsId = parts.shift();
                var mlsNumber = parts.join(":");
                holder.find("input[name=mls_id]").val(mlsId);
                holder.find("input[name=mls_number]").val(mlsNumber);
                $("#submit").css("display", "inline-block");
                $("#input1").attr("disabled", true);
                $("#cleartextbutton1").css("display", "inline-block");
                $("#submitbtn").focus();
            },
            focus: function (event, ui) {
                event.preventDefault();
                $("#not-found, #not-found2, #submit").hide();
            },
            autoFocus: true,
            highlight: true,
            appendTo: holder,
            minLength: 4,
        });
        if (isMobile) {
            input.autocomplete("widget").off("mouseenter");
        }

        let submitButtonFromDashboard = $(
            ".dashboard-listing-search #submitbtn"
        );
        if (submitButtonFromDashboard && submitButtonFromDashboard.length > 0) {
            submitButtonFromDashboard.click(function (event) {
                event.preventDefault();

                function createBoostChooseWhatToPromoteEZLink(
                    mls_id,
                    mls_number
                ) {
                    let url =
                        "/dashboard/easy_checkout/choose_what_to_promote/boost";

                    const params = new URLSearchParams({
                        mls_id: mls_id,
                        mls_number: mls_number,
                        autoNavigate: 1,
                    });
                    const urlParamString = params.toString();
                    url += "?" + urlParamString;
                    return url;
                }

                const mlsId = holder.find("input[name=mls_id]").val();
                const mlsNumber = holder.find("input[name=mls_number]").val();
                window.location.href = createBoostChooseWhatToPromoteEZLink(
                    mlsId,
                    mlsNumber
                );
            });
        }
    });
}

function initSlideShow() {
    jQuery(".slideshow").fadeGallery({
        slides: ".slide",
        btnPrev: ".btn-prev",
        btnNext: ".btn-next",
        useSwipe: false,
        autoRotation: false,
        switchTime: 5000,
        autorotationStopAfterClick: true,
        onInit: function (self) {
            self.gallery.on("in-viewport", function (e, state) {
                if (state) {
                    self.startRotation();
                }
            });
        },
    });
}

// cycle scroll gallery init
function initCycleCarousel() {
    jQuery(".carousel").scrollAbsoluteGallery({
        mask: ".mask",
        slider: ".slideset",
        slides: ".slide",
        stretchSlideToMask: false,
        pauseOnHover: true,
        maskAutoSize: true,
        autoRotation: false,
        switchTime: 3000,
        handleTouch: false,
        animSpeed: 500,
        onInit: function (self) {
            jQuery(".list-img").hide();
            window.carousel = self;
            setTargets(self);
            self.resizeSlides();
        },
        onChange: function (self) {
            self.resizeSlides();
            self.resizeHolder();
            self.setSlidesPosition(self.currentIndex);
        },
    });

    function setTargets(self) {
        var slides = self.slides;
        var links = slides.find("[data-target]");

        var switchSlides = function (e) {
            e.preventDefault();
            self.resizeSlides();
            self.resizeHolder();

            var currentLink = jQuery(e.currentTarget);
            var target = jQuery("#" + currentLink.data("target"));

            if (target.length) {
                /**
                 * So this "library" sets the height absolutely, so if one of the slides is much taller then the rest
                 * we get a bunch of whitespace that we don't want.
                 * This is a quick fix that will hide the images which is usually the culprit.
                 */
                if (target.hasClass("select-img")) {
                    jQuery(".list-img").show();
                } else {
                    jQuery(".list-img").hide();
                }

                self.numSlide(slides.index(target));
            }
        };

        links.on("click", switchSlides);
    }
}

function initTermsOfUse() {
    let cookie = readCookie("terms-of-use");

    if (!cookie) {
        jQuery(".terms-of-use--js").show();
    }

    jQuery(".terms-of-use__dismiss--js").click(function () {
        createCookie("terms-of-use", "1", 900);
        $(this).closest(".terms-of-use--js").fadeOut();
    });
}

var croppie = null;

function initFancybox() {
    jQuery("a.lightbox, [data-fancybox]").fancybox({
        parentEl: "body",
        margin: [50, 0],
        afterLoad: function (current, previous) {
            if (
                current &&
                current.current &&
                current.current.src &&
                jQuery(current.current.src).data("init-recurly")
            ) {
                initStripe();
            }

            var form = jQuery(current.href).find("form");

            if (form.length) {
                setTimeout(function () {
                    if (form.length) {
                        form[0].reset();
                    }
                }, 500);
            }
        },
    });
}

function isEmail(email) {
    var regex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}

function initStripe() {
    accountEmailErrorIndicator.hide();
    accountEmailDisabledErrorIndicator.hide();
    jQuery(".account_email_set-js").hide();

    let established_account_on_startup = $("[name=established_agentId]").val();

    let account_email_address_on_startup = $(
        "[name=account_email_address]"
    ).val();

    if (account_email_address_on_startup || established_account_on_startup) {
        jQuery(".account_email_missing_error").hide();
        jQuery(".account_email_set-js").show();
        jQuery(".account_email_not_set-js").hide();
    } else {
        jQuery(".account_email_set-js").hide();
        jQuery(".account_email_not_set-js").show();
        $("#show_clickable")
            .removeClass("btn green-bg show_clickable")
            .addClass("btn gray-bg show_clickable");
    }

    if (account_email_address_on_startup && $(".link").length === 0) {
        jQuery(".account_email_set-js").hide();
        jQuery(".account_email_not_set-js").show();
    }

    let account_email_form = document.getElementById("account_email_form");

    // Opens Payment Info form
    $(".account_email_address-js").change(function (e) {
        let account_email_address = $("[name=account_email_address]").val();
        if (!isEmail(account_email_address)) {
            jQuery(".account_email_missing_error").show();
            $("#show_clickable")
                .removeClass("btn green-bg show_clickable")
                .addClass("btn gray-bg show_clickable");
        } else {
            jQuery(".account_email_missing_error").hide();

            $("#show_clickable")
                .removeClass("btn gray-bg show_clickable")
                .addClass("btn green-bg show_clickable");
        }
    });

    $("#account_email_address").on("input", function (e) {
        let account_email_address = $("[name=account_email_address]").val();
        if (!isEmail(account_email_address)) {
            jQuery(".account_email_missing_error").show();
            $("#show_clickable")
                .removeClass("btn green-bg show_clickable")
                .addClass("btn gray-bg show_clickable");
        } else {
            jQuery(".account_email_missing_error").hide();

            $("#show_clickable")
                .removeClass("btn gray-bg show_clickable")
                .addClass("btn green-bg show_clickable");
        }
    });

    $("#checkout-button").on("click", function (e) {
        $("#checkout-button")
            .removeClass("checkout-button-js box-billing-btn__button__checkout")
            .addClass(
                "checkout-button-js box-billing-btn__button__checkout__disabled"
            );
    });

    $("[data-show]").on("click", function (e) {
        $("#checkout-button")
            .removeClass("checkout-button-js box-billing-btn__button__checkout")
            .addClass(
                "checkout-button-js box-billing-btn__button__checkout__disabled"
            );
        $("#card-popup").show();
        $("html, body").animate(
            {
                scrollTop: $(this).offset().top,
            },
            2000
        );
    });

    $(".show_clickable").on("click", function (e) {
        let customer_short_code = $("[name=customer_short_code]").val();
        let email_in_use = false;
        let current_user = false;
        let account_email_address = $("[name=account_email_address]").val();

        let cart_id = $("[name=cart_id]").val();
        let cartType =
            $("[name=cart_type]").val() === "1"
                ? "easy_promo_checkout"
                : "easy_checkout";

        var path =
            "/dashboard/" +
            cartType +
            "/account_email_check/" +
            customer_short_code +
            "/" +
            cart_id;

        if (account_email_address && !established_account_on_startup) {
            $.ajax({
                type: "POST",
                url: path,
                data: $(account_email_form).serialize(),
                beforeSend: function () {
                    loadingIndicator.show();
                    let clickElement =
                        document.getElementById("show_clickable");
                    clickElement.textContent = "Loading";
                    $("#show_clickable")
                        .removeClass("btn green-bg show_clickable")
                        .addClass("btn gray-bg show_clickable");
                },
                dataType: "json",
                success: function (data) {
                    email_in_use = data.account_email_in_use;
                    current_user = data.current_user;
                },
                error: function () {
                    loadingIndicator.hide();
                },
                complete: function () {
                    if (!email_in_use) {
                        document.getElementsByClassName(
                            "account_email_address-js"
                        )[0].disabled = true;

                        $("[name=email_address]").val(account_email_address);
                        $("#card-popup").show();
                        $("html, body").animate(
                            {
                                scrollTop: $(".show_clickable").offset().top,
                            },
                            2000
                        );
                        loadingIndicator.hide();
                        accountEmailErrorIndicator.hide();
                        accountEmailDisabledErrorIndicator.hide();
                        var disabledElement =
                            document.getElementById("show_clickable");
                        disabledElement.textContent =
                            "Adding Billing Information...";
                        var accountEmailSetElement = document.getElementById(
                            "account_email_set-js"
                        );
                        accountEmailSetElement.textContent =
                            account_email_address;
                        jQuery(".account_email_set-js").show();
                        jQuery(".account_email_not_set-js").hide();
                    } else {
                        if (!current_user) {
                            accountEmailDisabledErrorIndicator.show();
                        } else {
                            accountEmailErrorIndicator.show();
                        }
                        $("#show_clickable")
                            .removeClass("btn gray-bg show_clickable")
                            .addClass("btn green-bg show_clickable");
                        let clickElement =
                            document.getElementById("show_clickable");
                        clickElement.textContent = "Add Billing Information";
                        loadingIndicator.hide();
                    }
                },
            });
        } else {
            let clickElement = document.getElementById("show_clickable");
            clickElement.textContent = "Add Billing Information";
            $("#show_clickable")
                .removeClass("btn green-bg show_clickable")
                .addClass("btn gray-bg show_clickable");
            loadingIndicator.hide();

            $("#card-popup").show();
            $("html, body").animate(
                {
                    scrollTop: $(".show_clickable").offset().top,
                },
                2000
            );
            // loadingIndicator.hide();
            accountEmailErrorIndicator.hide();
            accountEmailDisabledErrorIndicator.hide();
        }
    });

    // Closes Payment Info form
    $(".holder-submit").on("click", ".close", function (e) {
        $("#card-popup").hide();
        if (!established_account_on_startup) {
            document.getElementsByClassName(
                "account_email_address-js"
            )[0].disabled = false;
        }

        $("#checkout-button")
            .removeClass(
                "checkout-button-js box-billing-btn__button__checkout__disabled"
            )
            .addClass("checkout-button-js box-billing-btn__button__checkout");

        showAddPaymentButton.show();
        $("#show_clickable")
            .removeClass("btn gray-bg show_clickable")
            .addClass("btn green-bg show_clickable");
        if ($(".link").length === 0) {
            let clickElement = document.getElementById("show_clickable");
            clickElement.textContent = "Add Billing Information";
        }
    });

    $(".reset-email").on("click", function (e) {
        if (established_account_on_startup) {
            jQuery(".account_email_set-js").show();
            jQuery(".account_email_not_set-js").hide();
        }

        if ($(".link").length === 0) {
            jQuery(".account_email_set-js").hide();
            jQuery(".account_email_not_set-js").show();
        }
    });

    // this needs to be grabbed from the config for live v test
    var stripeKey = jQuery("body").data("stripe-key");
    var stripe = Stripe(stripeKey);
    var elements = stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    var style = {
        base: {
            fontSize: "16px",
            color: "#32325d",
        },
    };

    // Create an instance of the card Element.
    var card = elements.create("card", { style: style });

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount("#card-element");

    // listen for potential user input errors and display to user
    card.addEventListener("change", function (event) {
        var displayError = $("#card-errors");
        if (event.error) {
            displayError.show();
            displayError.textContent = event.error.message;
        } else {
            displayError.hide();
            displayError.textContent = "";
        }
    });

    // Create a token or display an error when the form is submitted.
    var form = document.getElementById("payment-form");

    form.addEventListener("submit", function (event) {
        event.preventDefault();

        var custData = {
            name:
                $("input[name=first_name]").val() +
                " " +
                $("input[name=last_name]").val(),
            address_line1: $("input[name=address1]").val(),
            address_city: $("input[name=city]").val(),
            address_state: $("input[name=state]").val(),
            address_country: $("select[name=country]").val(),
        };

        stripe.createToken(card, custData).then(function (result) {
            if (result.error) {
                // Inform the customer that there was an error.
                var errorElement = document.getElementById("card-errors");
                errorElement.textContent = result.error.message;
            } else {
                // Send the token to your server.
                stripeTokenHandler(result.token, event);
            }
        });
    });

    function initMask() {
        jQuery(".card-input").mask("9999 9999 9999 9999");
        jQuery(".date-input").mask("99/99");
        jQuery(".code-input").mask("999");
        jQuery(".zip-input").mask("99999");
    }

    function stripeTokenHandler(token, event) {
        // Insert the token ID into the form so it gets submitted to the server
        var form = document.getElementById("payment-form");
        var hiddenInput = document.createElement("input");
        hiddenInput.setAttribute("type", "hidden");
        hiddenInput.setAttribute("name", "stripe_token");
        hiddenInput.setAttribute("value", token.id);
        form.appendChild(hiddenInput);

        // We have two forms on the cart summary page payment-form and the place order form
        // we need the subscribe and save info from the order form on the payment form so that we can
        // rerender the selections of the user.
        $(form).append($("[name='applied_coupon']").clone());

        let value = $("[name=subscribe_and_save]:checked").val();
        $(form).append(
            "<input type='hidden' name='subscribe_and_save' value='" +
                value +
                "'>"
        );

        $("[name='subscribe_and_save_subs[]']:checked").each(function () {
            $(form).append(
                "<input type='checkbox' name='subscribe_and_save_subs[]' value='" +
                    $(this).val() +
                    "' checked style='display:none'>"
            );
        });

        let isIndependentPage = $("[name=is_independent_page]").val() === "1";

        if (isIndependentPage) {
            let customerShortCode = $("[name=customer_short_code]").val();
            let currentContext = $("[name=current_context]").val();
            $("#payment-form button[type=submit]").attr("disabled", true);
            loadingIndicator.show();
            $.ajax({
                type: "POST",
                url:
                    "/dashboard/boost_cart/stripe_payment_form/" +
                    customerShortCode +
                    "?current_context=" +
                    currentContext,
                data: $(form).serialize(),
                dataType: "json",
                success: function (data) {
                    let stripeSuccessModal = new GenericBoostModal(
                        ".billing-form", // container holding the modal opener - high enough?
                        ".update-payment", // modal opening link
                        ".stripe-update-payment-modal--js", // modal
                        ".stripe-update-payment-modal__close--js", // closeModalHandler
                        "agent-promo-edit-campaign-modal--active", // modalActiveClass
                        "agent-promo-edit-campaign-modal__bg" // modalBackgroundClass
                    );
                    let messageElement = document.getElementById(
                        "payment-updated-message"
                    );
                    let detailMessageElement = document.getElementById(
                        "payment-updated-message-detail"
                    );
                    // Initialize the modal

                    messageElement.textContent = data["message"];
                    detailMessageElement.textContent = data["detail_message"];

                    // the modal won't pop if the button to pop the modal is disabled, so mark it good first
                    $("#payment-form button[type=submit]").attr(
                        "disabled",
                        false
                    );

                    // Then open the modal!
                    stripeSuccessModal.open(event);
                    loadingIndicator.hide();
                    stripeSuccessModal.stopListeningForClicks(); // once opened, we don't need to listen for more clicks and unintentionally block new submits
                },
                error: function (data) {
                    let errorElement = document.getElementById("card-errors");
                    errorElement.textContent = data.responseJSON.detail_message;
                    errorElement.style.display = "block";
                    $("#payment-form button[type=submit]").attr(
                        "disabled",
                        false
                    );
                    loadingIndicator.hide();
                },
            });
        } else {
            // Submit the form
            form.submit();

            // make sure they don't submit more than once
            $("#payment-form button[type=submit]").attr("disabled", true);
        }
    }
}

// initialize custom form elements
function initLaunchpadCustomForms() {
    jcf.setOptions("Select", {
        wrapNative: false,
        wrapNativeOnMobile: false,
    });
    jcf.replaceAll();

    jQuery(".close-icon-js").on("click", clearForm);
}

function clearForm() {
    $("#cleartextbutton1").css("display", "none");
    $("#input1").attr("disabled", false);
    $("#input1").val("");
    $("#submit").css("display", "none");
}

function initRetinaCover() {
    jQuery(".bg-stretch").retinaCover();
    jQuery(".profile-holder .photo").retinaCover();
}

function savePhoto() {
    var savePhotoText = $("#save-photo-text");
    // Ensure that the button isn't already loading which would mean there's a request inflight already
    if (!savePhotoText.hasClass("loading")) {
        setCroppieImageSizes();

        var form = $("#edit-agent")[0];
        var data = new FormData(form);

        var hiddenForm = jQuery("form[name=main]")[0];
        var customerShortCode = jQuery(hiddenForm).find(
            "input[name=customer_short_code]"
        )[0].value;
        var cartId = jQuery(hiddenForm).find("input[name=cart_id]")[0].value;
        var path =
            "/dashboard/boost_cart/saveagentphoto/" +
            customerShortCode +
            "/" +
            cartId;
        $.ajax({
            type: "POST",
            enctype: "multipart/form-data",
            url: path,
            data: data,
            processData: false,
            contentType: false,
            cache: false,
            timeout: 600000,
            success: function (data) {
                $("#photo_url").val(data.photo_url);
                $("#photo_result").attr("src", data.photo_url);

                $("#profile-img").attr("src", "#");

                togglePhotoSaving(false);

                croppie.destroy();
                croppie = null;

                if (
                    data == null ||
                    data.length === 0 ||
                    data.success !== true ||
                    data.photo_url.length === 0
                ) {
                    var errorMessage = data.error;
                    alert(
                        errorMessage
                            ? errorMessage
                            : "There was a problem saving your photo. Please try a different photo or try again later."
                    );
                    return;
                }
            },
            error: function (e) {
                togglePhotoSaving(false);
                alert(
                    "There was a problem saving your photo. Please try a different photo or try again later."
                );
            },
        });

        togglePhotoSaving(true);
    } else {
        console.warn("Another photo request is already being made!");
    }
}

function togglePhotoSaving(isSaving) {
    if (isSaving) {
        $("#save-photo-text").addClass("loading").text("Saving...");
        $("#portrait-input").prop("disabled", true);
    } else {
        $("#save-photo-text").removeClass("loading").text("Save Photo");
        $("#portrait-input").prop("disabled", false);

        $("#upload-image").hide();
        $("#upload-image-text").text("Upload Photo");
    }
}

function portraitChangeHandler() {
    var saveButton = $("#upload-image");
    var files = this.files;

    if (!files.length || !window.FileReader) {
        return;
    }

    if (/^image/.test(files[0].type)) {
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);

        reader.onloadend = function () {
            var sourceImage = this.result;

            var img = document.getElementById("profile-img");
            // If there's already an instance of Croppie just update it with the new image rather than create
            // another instance
            if (!croppie) {
                croppie = new Croppie(img, {
                    boundary: { width: 200, height: 200 },
                    viewport: { width: 200, height: 200, type: "circle" },
                });
            }
            croppie.bind({
                url: sourceImage,
            });

            $(".profile-update-form").on("submit", function () {
                setCroppieImageSizes();
            });

            saveButton.show();

            $("#upload-image-text").text("Select Different Photo");
        };
    }
}

$(document).ready(function () {
    var saveButton = $("#upload-image");
    saveButton.hide();

    // i don't know why, but using jquery wasn't picking up this onchange event - vanilla js works!
    var portraitInput = document.querySelector("#portrait-input");
    if (portraitInput) {
        portraitInput.addEventListener("change", portraitChangeHandler);
    }

    // BUT, the jquery on click does work!!!
    saveButton.on("click", savePhoto);
});

function setCroppieImageSizes() {
    var results = croppie.get();
    var points = results["points"];
    $("#port_x").val(points[0]);
    $("#port_y").val(points[1]);
    $("#port_x2").val(points[2]);
    $("#port_y2").val(points[3]);
    $("#zoom").val(results["zoom"]);
}

function customURLInput(value) {
    jQuery("#llp_custom").click();
}

function initLayoutImageHandlers() {
    jQuery(".setLayoutImage--js").each(function () {
        let image = jQuery(this);
        let url = image.attr("data-url");
        let displayAd = image.attr("data-display_ad");
        let original = image.attr("data-original");
        let selectedLayout = image.attr("data-layout");

        image.on("click", function (e) {
            e.preventDefault();
            setLayoutImage(url, displayAd, original, selectedLayout);
            gotoSlide("#home");
        });
    });
}

function closeWebviewEventHandler() {
    jQuery(".close-webview--js").click(function () {
        window.location.href = "homespotterapp://close";
    });
}

function goBackButtonHandler() {
    jQuery("a.cart-summary__title__back").click(function () {
        window.history.back();
        return false;
    });
}

function setLayoutImage(listingUrl, displayUrl, originalUrl, selectedLayout) {
    let $image_url = jQuery("input[name=image_url]");
    let $image2_url = jQuery("input[name=image2_url]");
    let $selectedLayout = jQuery("input[name=selected_layout]");
    let $original_url_ezc = jQuery("input[name=croppedImage]");
    let $original_url = jQuery("input[name=original_image_url]");
    let $main_image = jQuery("#main-image, .ad-preview__img--js");
    let $displayAdImage = jQuery("#displayad-image");

    $image_url.val(listingUrl).trigger("change");
    $image2_url.val(displayUrl).trigger("change");
    $original_url.val(originalUrl).trigger("change");
    $original_url_ezc.val(originalUrl).trigger("change");
    $selectedLayout.val(selectedLayout).trigger("change");

    $main_image.attr("src", listingUrl).trigger("change");
    $main_image.attr("srcset", listingUrl + " 2x");

    $displayAdImage.attr("src", displayUrl).trigger("change");
    $displayAdImage.attr("srcset", displayUrl + " 2x");

    enableSaveButton();
}

function enableSaveButton() {
    jQuery("#savebutton").addClass("active");
}

function initGetLayoutEventHandlers() {
    jQuery(".photo_layout--js").each(function () {
        let link = jQuery(this);
        let photoUrl = link.attr("data-photoUrl");

        link.on("click", function (e) {
            e.preventDefault();
            getLayouts(photoUrl, false);
        });
    });
}

function saveAgent() {
    var form = jQuery("form[name=edit-agent]")[0];

    var hiddenForm = jQuery("form[name=main]")[0];
    var customerShortCode = jQuery(hiddenForm).find(
        "input[name=customer_short_code]"
    )[0].value;
    var cartId = jQuery(hiddenForm).find("input[name=cart_id]")[0].value;

    var path =
        "/dashboard/" +
        getCartController() +
        "/saveagent/" +
        customerShortCode +
        "/" +
        cartId;
    var dataToPost = jQuery("form[name=edit-agent]").serialize();

    jQuery
        .post(path, dataToPost, function (data, textStatus) {
            if (data.length == 0 || textStatus !== "success") {
                layoutsFailedHandler();
                return;
            }
            getLayouts(selectedPhotoURL, true);
        })
        .fail(function (jqxhr, textStatus, error) {
            layoutsFailedHandler();
            console.warn(error);
        });
}

function getCartController() {
    var controller = jQuery('[name="cart_controller"]').val();

    if (controller) {
        return controller;
    } else {
        return "boost_cart";
    }
}

function saveAgentHandlers() {
    var editPhotoform = $(".edit-photo-and-name__form--js");

    editPhotoform.submit(function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        saveAgent();
    });
}

var descriptionPreviouslyHidden = false;
var savedDescription = "";
var selectedPhotoURL = null;
var savedPageInfo = {};

function getLayouts(baseUrl, skipEdit) {
    selectedPhotoURL = baseUrl;
    var editAgent = jQuery("#edit-photo-and-name").length != 0;
    if (editAgent && !skipEdit) {
        gotoSlide("#edit-photo-and-name");
        return;
    }

    gotoSlide("#generating-layouts");
    var form = jQuery("form[name=main]")[0];
    var customerShortCode = jQuery(form).find(
        "input[name=customer_short_code]"
    )[0].value;
    var cartId = jQuery(form).find("input[name=cart_id]")[0].value;

    var path = null;
    var controller = getCartController();

    if ("boost" == controller) {
        // boost
        var campaignId = jQuery(form).find("input[name=campaign_id]")[0].value;
        path =
            "/dashboard/" +
            controller +
            "/getlayouts/" +
            customerShortCode +
            "/" +
            campaignId +
            "?base_url=" +
            encodeURIComponent(baseUrl);
        var agentId = GetURLParameter("agent");
        if (agentId) {
            // this can happen/is needed when we are coming from an email and are doing token authentication
            path += "&agent=" + agentId;
        }
        // else editing from the boost dashboard detail page and we don't need it
    } else {
        // boost_cart
        path =
            "/dashboard/" +
            controller +
            "/getlayouts/" +
            customerShortCode +
            "/" +
            cartId +
            "/?base_url=" +
            encodeURIComponent(baseUrl);
        path += "&" + GetUrlContextParametersString();
    }

    jQuery
        .getJSON(path, function (data) {
            let fbLayouts = data.facebook;
            let displayAd = data.beeswax;
            let original = data.original;
            window.numLayoutImages = fbLayouts.length;
            window.numLayoutImagesLoaded = 0;
            jQuery("#layouts-holder").html("");
            if (fbLayouts.length == 0) {
                layoutsFailedHandler();
                return;
            }
            jQuery.each(fbLayouts, function (i, layout) {
                let html =
                    "<li>" +
                    '<a href="#" class="setLayoutImage--js" data-layout=\'' +
                    layout.layout +
                    "' data-url='" +
                    layout.url +
                    "' data-display_ad='" +
                    displayAd +
                    "' data-original='" +
                    original +
                    "'>" +
                    '<div class="block-img">' +
                    '<img id="layout_' +
                    i +
                    '" src="' +
                    layout.url +
                    '" srcset="' +
                    layout.url +
                    ' 2x" alt="Layout preview" width="290" height="144">' +
                    "</div>" +
                    "</a></li>";
                jQuery("#layouts-holder").append(html);
                jQuery("img#layout_" + i).load(layoutImageLoaded);
                initLayoutImageHandlers();
            });
        })
        .fail(function (jqxhr, textStatus, error) {
            console.log(error);
            layoutsFailedHandler();
        });
}

function layoutsFailedHandler() {
    alert(
        "Whoops! There seems to be a problem with the server. Please try again in a few minutes."
    );
    setTimeout(function () {
        gotoSlide("#edit-photo");
    }, 100);
}

function layoutImageLoaded() {
    window.numLayoutImagesLoaded++;
    if (window.numLayoutImagesLoaded >= window.numLayoutImages) {
        gotoSlide("#edit-layout");
    }
}

function getSlideIndex(selector) {
    return carousel.slides.index(jQuery(selector));
}

function gotoSlide(selector) {
    carousel.numSlide(getSlideIndex(selector));
}

// this is called when changing the fb page when manually boosting AND for https://dev.rest.homespotter.com/launchpad/thankyou/boost/connectwithfacebook
function initLaunchPadFacebook() {
    //only called on pages that use FB integration, by facebook framework
    $("#fb-pageaccess")
        .off("click")
        .click(function () {
            var button = $(this);
            var indicator = button
                .closest(".fb-btn-holder")
                .find(".fb-btn-loading");
            var lookForPopup = button
                .closest(".fb-btn-holder")
                .find(".fb-look-for-popup");
            var permissions = [
                "pages_manage_ads",
                "business_management",
                "pages_manage_metadata",
                "pages_read_engagement",
                "pages_read_user_content",
            ];

            button.hide();
            indicator.show();
            lookForPopup.show();
            var form = button.closest("form.main");
            var pageids = [];

            var postPermission = function (response) {
                lookForPopup.hide();
                if (response.status === "connected") {
                    var fbUserId = response.authResponse.userID;
                    var fbAccessToken = response.authResponse.accessToken;
                    var scopes = response.authResponse.grantedScopes.split(",");

                    var missingPermissions = permissions.filter(function (
                        permission
                    ) {
                        return scopes.indexOf(permission) === -1;
                    });

                    if (missingPermissions.length === 0) {
                        if (window.debug)
                            console.log("All Permissions are accounted for!");

                        jQuery
                            .post(
                                "/launchpad/getpages/boost",
                                {
                                    fb_user_id: fbUserId,
                                    fb_access_token: fbAccessToken,
                                },
                                function (pageids, textStatus) {
                                    //if there is one page which we have been given permissions use it
                                    if (pageids.length > 0) {
                                        $("#fb-initial-login").hide();
                                        $("#fb-choose-page").show();
                                        //selector
                                        var allItems = "";
                                        for (
                                            var i = 0;
                                            i < pageids.length;
                                            i++
                                        ) {
                                            allItems +=
                                                `<a href="#" data-fb-page-id='${pageids[i]["id"]}' data-fb-page-access-token='${pageids[i]["access_token"]}' data-fb-page-name='${pageids[i]["name"]}' class="fb-page">\n` +
                                                '<img id="' +
                                                pageids[i]["id"] +
                                                '" class="fb-icon" src="' +
                                                makeFbPageIconFromPageId(
                                                    pageids[i]["id"]
                                                ) +
                                                '" width="40" />' +
                                                '<span class="fb-page-name">' +
                                                pageids[i]["name"] +
                                                "</span>" +
                                                "</a>";
                                        }
                                        $("#fb-pages")
                                            .empty()
                                            .append(allItems)
                                            .show();

                                        // Actual click handler for choosing a facebook page
                                        $("#fb-pages").on(
                                            "click",
                                            "a",
                                            function (e) {
                                                indicator.show();

                                                function saveFacebookPageSelection(
                                                    fbPageId,
                                                    fbPageName,
                                                    fbpageAccessToken,
                                                    adminLevel
                                                ) {
                                                    if (window.debug)
                                                        console.log(
                                                            "args:",
                                                            fbPageId,
                                                            fbPageName,
                                                            fbpageAccessToken,
                                                            adminLevel
                                                        );
                                                    if (window.debug)
                                                        console.log(
                                                            "$('#home')",
                                                            $("#home")
                                                        );

                                                    if ($("#home").length) {
                                                        var $editIcon = jQuery(
                                                            "#edit-icon, .ad-preview__facebook-image--js"
                                                        );
                                                        var $editName = jQuery(
                                                            "#edit-name, .ad-preview__facebook-name--js"
                                                        );

                                                        // normal boost dashboard situation
                                                        savedPageInfo["image"] =
                                                            jQuery(
                                                                "#edit-icon"
                                                            ).attr("src");
                                                        savedPageInfo["name"] =
                                                            jQuery(
                                                                "#edit-name"
                                                            ).text();
                                                        savedPageInfo[
                                                            "fb_user_id"
                                                        ] = jQuery(
                                                            "input[name=fb_user_id]"
                                                        ).val();
                                                        savedPageInfo[
                                                            "fb_access_token"
                                                        ] = jQuery(
                                                            "input[name=fb_access_token]"
                                                        ).val();
                                                        savedPageInfo[
                                                            "fb_page_id"
                                                        ] = jQuery(
                                                            "input[name=fb_page_id]"
                                                        ).val();
                                                        savedPageInfo[
                                                            "fb_page_access_token"
                                                        ] = jQuery(
                                                            "input[name=fb_page_access_token]"
                                                        ).val();

                                                        jQuery(
                                                            "input[name=fb_user_id]"
                                                        ).val(fbUserId);
                                                        jQuery(
                                                            "input[name=fb_access_token]"
                                                        ).val(fbAccessToken);
                                                        jQuery(
                                                            "input[name=fb_page_id]"
                                                        ).val(fbPageId);
                                                        jQuery(
                                                            "input[name=fb_page_access_token]"
                                                        ).val(
                                                            fbpageAccessToken
                                                        );
                                                        jQuery(
                                                            "input[name=fb_page_change_at_admin_level]"
                                                        ).val(adminLevel);

                                                        $editIcon.attr(
                                                            "src",
                                                            makeFbPageIconFromPageId(
                                                                fbPageId
                                                            )
                                                        );
                                                        $editName.text(
                                                            fbPageName
                                                        );

                                                        gotoSlide("#home");

                                                        logBoostCartEvent(
                                                            "Completed Connect to Facebook Form"
                                                        );
                                                    } else {
                                                        // when does this case occur?
                                                        // It is used for https://dev.rest.homespotter.com/launchpad/thankyou/boost/connectwithfacebook
                                                        jQuery(
                                                            "input[name=fb_user_id]"
                                                        ).val(fbUserId);
                                                        jQuery(
                                                            "input[name=fb_access_token]"
                                                        ).val(fbAccessToken);
                                                        jQuery(
                                                            "input[name=fb_page_id]"
                                                        ).val(fbPageId);
                                                        jQuery(
                                                            "input[name=fb_page_access_token]"
                                                        ).val(
                                                            fbpageAccessToken
                                                        );
                                                        connectwithfacebook();
                                                    }
                                                }

                                                /*
                                                 * When the use chooses a new facebook page, if they are in an agent context then they DO NOT get prompted and the page becomes their default.
                                                 * If they are an admin, they are given a prompt to ask how they want the facebook page applied.
                                                 *
                                                 */
                                                const body = $("body");
                                                const currentContext =
                                                    sanitizeAdminLevelName(
                                                        body.data(
                                                            "current-context"
                                                        )
                                                    );
                                                const selectedPageId =
                                                    $(this).attr(
                                                        "data-fb-page-id"
                                                    );
                                                const selectedPageName =
                                                    $(this).attr(
                                                        "data-fb-page-name"
                                                    );
                                                const selectedPageAccessToken =
                                                    $(this).attr(
                                                        "data-fb-page-access-token"
                                                    );

                                                if (
                                                    !currentContext ||
                                                    currentContext.indexOf(
                                                        "agent"
                                                    ) !== -1 ||
                                                    jQuery(
                                                        'input[name="is_edit"]'
                                                    ).val()
                                                ) {
                                                    saveFacebookPageSelection(
                                                        selectedPageId,
                                                        selectedPageName,
                                                        selectedPageAccessToken,
                                                        "agent"
                                                    );
                                                } else {
                                                    if (
                                                        $(
                                                            ".setDefaultFbPageRadioButton"
                                                        ).length > 1
                                                    ) {
                                                        // prep the presentation of the modal
                                                        $(
                                                            "#admin-set-block-fb-page-icon"
                                                        ).attr(
                                                            "src",
                                                            makeFbPageIconFromPageId(
                                                                selectedPageId
                                                            )
                                                        );
                                                        $(
                                                            "#admin-set-block-fb-page-name"
                                                        ).text(
                                                            selectedPageName
                                                        );
                                                        $(
                                                            "#companyLevelRadio"
                                                        ).hide();
                                                        $(
                                                            "#brokerLevelRadio"
                                                        ).hide();

                                                        switch (
                                                            currentContext
                                                        ) {
                                                            case "company":
                                                                $(
                                                                    "#companyLevelRadio"
                                                                ).show();
                                                            case "broker":
                                                                $(
                                                                    "#brokerLevelRadio"
                                                                ).show();
                                                            default:
                                                                $(
                                                                    "#officeLevelRadio"
                                                                ).show();
                                                        }

                                                        // set up listeners for the 'labels' so when they are clicked, they trigger the radio button
                                                        $(
                                                            ".clickable-label"
                                                        ).click((e) => {
                                                            $(e.target)
                                                                .closest(
                                                                    ".setDefaultFbPageRadioButton"
                                                                )
                                                                .find(
                                                                    "input[name=fb-page-admin-set]"
                                                                )
                                                                .trigger(
                                                                    "click"
                                                                );
                                                        });

                                                        // set up listeners for the modal & their clean up
                                                        function cleanUpListeners() {
                                                            $(
                                                                "#fb-page-admin-level-cancel-button"
                                                            ).off();
                                                            $(
                                                                "#submit-fb-page-admin-level"
                                                            ).off();
                                                            $("body").css(
                                                                "overflow",
                                                                "auto"
                                                            ); // allow scrolling of body when we leave the modal
                                                            $(
                                                                ".clickable-label"
                                                            ).off();
                                                        }

                                                        $(
                                                            "#fb-page-admin-level-cancel-button"
                                                        ).click(() => {
                                                            cleanUpListeners();
                                                            $(
                                                                "#fb-page-admin-level-modal-prompt"
                                                            ).addClass(
                                                                "full-screen-modal-hide"
                                                            );
                                                            if (
                                                                $("#home")
                                                                    .length
                                                            ) {
                                                                gotoSlide(
                                                                    "#home"
                                                                );
                                                            }
                                                        });

                                                        $(
                                                            "#submit-fb-page-admin-level"
                                                        ).click(() => {
                                                            cleanUpListeners();
                                                            const selectedAdminLevel =
                                                                $(
                                                                    "input[name='fb-page-admin-set']:checked"
                                                                ).val();

                                                            $(
                                                                "#fb-page-admin-level-modal-prompt"
                                                            ).addClass(
                                                                "full-screen-modal-hide"
                                                            );
                                                            saveFacebookPageSelection(
                                                                selectedPageId,
                                                                selectedPageName,
                                                                selectedPageAccessToken,
                                                                selectedAdminLevel
                                                            );
                                                        });
                                                        // reveal the modal
                                                        $(
                                                            "#fb-page-admin-level-modal-prompt"
                                                        ).removeClass(
                                                            "full-screen-modal-hide"
                                                        );
                                                        $("body").css(
                                                            "overflow",
                                                            "hidden"
                                                        ); // prevent scrolling the body when in modal
                                                    }
                                                    // else - we only have one radio button in the modal (the Just 1 ad option)
                                                    // that is the only choice, then we don't need to save anything
                                                }
                                            }
                                        );
                                    } else {
                                        button.show();
                                        indicator.hide();
                                        $("#fb-initial-login").show();
                                        $("#to-publish").hide();
                                        $("#fb-choose-page").hide();
                                        $("#to-publish-error-page").show();
                                    }
                                }
                            )
                            .fail(function (jqxhr, textStatus, error) {
                                button.show();
                                indicator.hide();
                                $("#fb-initial-login").show();
                                $("#to-publish").hide();
                                $("#fb-choose-page").hide();
                                $("#to-publish-error-page").show();
                            });
                    } else {
                        console.log(
                            "Missing the following permissions: " +
                                missingPermissions.join()
                        );
                        button.show();
                        indicator.hide();
                        $("#fb-initial-login").show();
                        $("#to-publish").hide();
                        $("#fb-choose-page").hide();
                        $("#to-publish-error-perm").show();
                    }
                } else {
                    indicator.hide();
                    button.show();
                }
            };

            FB.login(
                function (response) {
                    postPermission(response);
                },
                {
                    scope: permissions.join(),
                    return_scopes: true,
                }
            );

            logBoostCartEvent("Viewed Connect to Facebook Form");
        });

    $("#fb-photo").click(function () {
        var button = $(this);
        var indicator = button
            .closest(".fb-btn-holder")
            .find(".fb-btn-loading");
        var is_launchpad = button.is(".launchpad--js");

        button.hide();
        indicator.show();
        var form = button.closest("form.fb-form");
        var fbImage = $("#photo_result");

        var grabFacebookPhoto = function (response) {
            if (response.status === "connected") {
                var fbUserId = response.authResponse.userID;
                var accessToken = response.authResponse.accessToken;

                var customerShortCode = jQuery(
                    "input[name=customer_short_code]"
                ).val();
                var cartId = jQuery("input[name=cart_id]").val();

                if (is_launchpad) {
                    FB.api(
                        "/me/picture",
                        "get",
                        { type: "large", redirect: false },
                        function (picResponse) {
                            if (window.debug) console.log(picResponse);
                            var fbPhotoUrl = picResponse.data.url;
                            var isPlaceholder = picResponse.data.is_silhouette;
                            if (!isPlaceholder) {
                                if (form) {
                                    form.find("input[name=fb_user_id]").val(
                                        fbUserId
                                    );
                                    form.find("input[name=fb_photo_url]").val(
                                        fbPhotoUrl
                                    );
                                    form.submit();
                                }
                                if (fbImage) {
                                    $("#fb_user_id").val(fbUserId);
                                    $("#photo_url").val(fbPhotoUrl);
                                    fbImage.attr("src", fbPhotoUrl);
                                    indicator.hide();

                                    logBoostCartEvent(
                                        "Connected Facebook Profile Pic"
                                    );
                                }
                            }
                        }
                    );
                } else {
                    jQuery.post(
                        "/dashboard/" +
                            getCartController() +
                            "/getpicture/" +
                            customerShortCode +
                            "/" +
                            cartId,
                        {
                            fb_user_id: fbUserId,
                            fb_access_token: accessToken,
                        },
                        function (returnValue, textStatus) {
                            if (returnValue.error) {
                                console.error(returnValue.message);
                            } else {
                                var pictureUrl = returnValue.result.data.url;
                                var isPlaceholder =
                                    returnValue.result.data.is_silhouette;

                                if (!isPlaceholder) {
                                    if (form) {
                                        form.find("input[name=fb_user_id]").val(
                                            fbUserId
                                        );
                                        form.find(
                                            "input[name=fb_photo_url]"
                                        ).val(pictureUrl);
                                        form.submit();
                                    }

                                    $("#fb_user_id").val(fbUserId);
                                    $("#photo_url").val(pictureUrl);
                                    fbImage.attr("src", pictureUrl);
                                    indicator.hide();

                                    logBoostCartEvent(
                                        "Connected Facebook Profile Pic"
                                    );
                                }
                            }
                        }
                    );
                }
            } else {
                console.warn("Not connected!", response);
                indicator.hide();
                button.show();
            }
        };

        FB.login(function (response) {
            grabFacebookPhoto(response);
        });
    });
}

function logBoostCartEvent(eventName) {
    var hiddenForm = jQuery("form[name=main]")[0];
    var customerShortCode = jQuery(hiddenForm).find(
        "input[name=customer_short_code]"
    )[0];
    var cartId = jQuery(hiddenForm).find("input[name=cart_id]")[0];
    if (customerShortCode != null && cartId != null) {
        logEvent(customerShortCode.value, eventName, cartId.value);
    }
}

function logEvent(customerShortCode, eventName, cartId) {
    // console.log('logEvent', customerShortCode, eventName, cartId);
    $.ajax({
        url:
            "/dashboard/" +
            getCartController() +
            "/javascript_log_event/" +
            customerShortCode +
            "/" +
            cartId,
        type: "POST",
        data: {
            cart_id: cartId,
            event_name: eventName,
        },
    }).done(function (data, statusText, jqXhr) {
        if (window.debug) console.log(data);
    });
}

function connectwithfacebook() {
    var form = jQuery("#main-form");
    form.submit();
}

function makeFbPageIconFromPageId(fbPageId) {
    return `https://graph.facebook.com/${fbPageId}/picture?type=square`;
}

function sanitizeAdminLevelName(uglyName) {
    if (!uglyName) return null;
    if (uglyName.indexOf("company") !== -1) return "company";
    if (uglyName.indexOf("broker") !== -1) return "broker";
    if (uglyName.indexOf("office") !== -1) return "office";
    return "agent";
}
